import React from 'react';

import { Description, Title, TitleWrapper, Wrapper } from './styles';

export interface Props {
  title?: string;
  description?: string;
  children: any;
}

const StandardSceneWrapper: React.FC<Props> = ({ title, description, children }) => {
  return (
    <Wrapper>
      {title && (
        <TitleWrapper>
          {title && <Title>{title}</Title>}
          {description && <Description>{description}</Description>}
        </TitleWrapper>
      )}
      {children}
    </Wrapper>
  );
};

export default StandardSceneWrapper;
